import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Button = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};

  border-radius: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.background.default};
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.04);
  cursor: ${({ as }) => (as ? 'default' : 'pointer')};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const IconContainer = styled.span`
  transform: rotate(270deg);
`;

export const CalendarColor = styled.span<{ $color: string }>`
  display: block;
  height: 1em;
  width: 0.3rem;

  background: ${({ $color }) => $color};
  border-radius: ${({ theme }) => theme.spacing(2)};
`;
